const PART_TYPES = {
  'BATTERY': 'battery',
  'CONSOLE': 'console',
  'DRIVER': 'driver',
  'DONGLE': 'dongle',
  'MOTOR': 'motor',
  'DISPLAY': 'display'
};

const partTypeNames = {
  [PART_TYPES.BATTERY]: 'Battery',
  [PART_TYPES.CONSOLE]: 'Console',
  [PART_TYPES.DRIVER]: 'Driver',
  [PART_TYPES.DONGLE]: 'Dongle',
  [PART_TYPES.MOTOR]: 'Motor',
  [PART_TYPES.DISPLAY]: 'Display'
};

const partTypesMappingToOld = {
  [PART_TYPES.BATTERY]: 'B',
  [PART_TYPES.CONSOLE]: 'C',
  [PART_TYPES.DRIVER]: 'D',
  [PART_TYPES.DONGLE]: 'G',
  [PART_TYPES.MOTOR]: 'M',
  [PART_TYPES.DISPLAY]: 'P'
};

export { PART_TYPES, partTypeNames, partTypesMappingToOld };
